module.exports = __webpack_public_path__ + "static/img/o3.1a33d42.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/home/o3.jpg
// module id = kQvQ
// module chunks = 1